<template>
  <section class="container service">
    <div class="service-inner">
      <ul class="service-wrapper clearfix">

        <li class="service-item content-item">
          <div class="service-item-inner">
            <div class="title-box" ref="serviceTitleBox">
<!--              <h3>-->
<!--                <span class="axis" style="color: #00c5e3; font-weight: 700">AXIS</span> 예배안내 & 오시는길<br>-->
<!--              </h3>-->
            </div>

          </div>
        </li>

        <li class="service-item map-item">
          <div class="service-item-inner">
<!--            <div class="service-item-img-box">-->
<!--                            <img src="../../../assets/axis/20240908_135636.jpg" alt="">-->
<!--            </div>-->
            <div class="map-box" ref="serviceKakaoMapBox">
              <KakaoMap />

            </div>
            <ul class="detail-wrapper clearfix">
              <li class="detail-item" ref="detailItem01">
                <h4>[ 주소 ]</h4>
                <p>
                  서울특별시 강동구 천중로27길 51 (서울특별시 강동구 천호동 219-2)
                </p>
              </li>
              <li class="detail-item" ref="detailItem02">
                <h4>[ 예배장소 & 시간 ]</h4>
                <p>교회4층 벧엘성전, 주일 오후 2시</p>
                <span class="important">
                  한 달에 주일이 다섯번 있는 경우, 마지막(다섯번째) 주일은 '패밀리주일'로 젊은이부 예배가 없습니다. 본교회 예배를 드려주세요!<br>
                  <span style="color: #555">- 본교회 예배 (1부 : 주일 오전 09:00분, 2부 : 주일 오전 11:15분) 지하 2층 예루살렘 성전</span>
                </span>
              </li>

              <li class="detail-item" ref="detailItem03">
                <h4>[ 예배안내 ]</h4>
                <p>
                  1부 - 14:00 ~ 15:20분 (찬양, 말씀)<br>
                  2부 - 15:30 ~ (순별 모임)<br>
                  <!--                    20세~24세 - 1청년, 25세~29세 - 1.5청년, 30세~49세 - 2청년-->
                </p>
              </li>
              <li class="detail-item" ref="detailItem04">
                <h4>[ 순모임안내 ]</h4>
                <p>
                  1청년 - 20세~24세<br>
                  1.5청년 - 25세~29세<br>
                  2청년 - 30세 이상
                  <!--                    20세~24세 - 1청년, 25세~29세 - 1.5청년, 30세~49세 - 2청년-->
                </p>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>


<script>
import KakaoMap from "@/components/core/KakaoMap.vue";

export default {
name: "Service",
  components: {KakaoMap},
  mounted() {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -150px 0px',  // 뷰포트 하단에서 200px 지나야만 트리거
      threshold: 0  // 요소의 30%가 보일 때 트리거
    };


    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 요소가 보이면 isVisible을 true로 설정
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    observer.observe(this.$refs.serviceTitleBox);
    observer.observe(this.$refs.serviceKakaoMapBox);
    observer.observe(this.$refs.detailItem01);
    observer.observe(this.$refs.detailItem02);
    observer.observe(this.$refs.detailItem03);
    observer.observe(this.$refs.detailItem04);
  },
}
</script>

<style scoped lang="scss">
  .service {

    padding-top: 80px;
    padding-bottom: 140px;

    .service-inner {

      .service-wrapper {

        max-width: 980px;
        width: 100%;
        margin: 0 auto;
        box-sizing: border-box;



        .service-item {

          float: left;
          width: 100%;

          &.content-item {
            text-align: center;
            .title-box {

              opacity: 0;
              transform: translateY(50px);
              transition: all .3s ease-out;

              &.visible {
                opacity: 1;
                transform: translateY(0);
              }

              h3 {
                margin-top: 15px;
                font-size: 30px;
                color: #000;
                line-height: 1.4;
                font-weight: 300;

                span {
                  font-weight: 300;
                }
              }

              h4 {
                margin-top: 20px;
                font-size: 20px;
                font-weight: 700;
                color: #333;
              }
            }



          }

          &.map-item {

            .map-box {
              margin-top: 0;

              opacity: 0;
              transform: translateY(50px);
              transition: all .3s ease-out;

              &.visible {
                opacity: 1;
                transform: translateY(0);
              }

            }

            .detail-wrapper {
              line-height: 1.4;
              box-sizing: border-box;
              padding: 24px 0;
              font-size: 16px;
              text-align: left;
              color: #333;

              .detail-item {

                margin-top: 20px;

                opacity: 0;
                transform: translateY(50px);
                transition: all .3s ease-out;

                &.visible {
                  opacity: 1;
                  transform: translateY(0);
                }

                &:first-child {
                  margin-top: 0;
                }
                p {
                  margin-top: 5px;
                }

                span {
                  &.important {
                    color: #FF6F61;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 1512px) {
    .service {
      box-sizing: border-box;
      padding: 25px;
      padding-top: 60px;
      padding-bottom: 60px;
    }
  }

  @media screen and (max-width: 768px) {
    .service .service-inner .service-wrapper .service-item.content-item .title-box h3 {
      font-size: 26px;
    }

    .service .service-inner .service-wrapper .service-item.map-item .detail-wrapper {
      font-size: 15px;
    }
  }
</style>